import {
    Directive,
    HostBinding,
    HostListener,
    Output,
    EventEmitter,
    Input,
    Renderer2,
    ElementRef
  } from "@angular/core";
  import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
  
  export interface FileHandle {
    file: File,
    url: SafeUrl
  }
  
  @Directive({
    selector: "[fileDrop]",
    exportAs: "FileDropDirective"
  })
  export class FileDropDirective {

    @Input("dropClass")
    dropClass: string;

    @Output('dropFiles') 
    dropFiles: EventEmitter<FileHandle[]> = new EventEmitter();
  
    @HostBinding("style.background") 
    background = "transparent";

    // @HostBinding("class") 
    // activeClass = "";
    
    constructor(private sanitizer: DomSanitizer, private renderer: Renderer2, private hostElement: ElementRef) { }
  
    private showState(active: boolean) {
      if (this.dropClass) {
        if (active) {
          this.renderer.addClass(this.hostElement.nativeElement, this.dropClass);
        } else {
          this.renderer.removeClass(this.hostElement.nativeElement, this.dropClass);
        }
        // activeClass = (active)? this.dropClass : '';
      } else {
        this.background = (active)? "rgba(0,0,0,.1)" : 'transparent';
      }
    }

    @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
      evt.preventDefault();
      evt.stopPropagation();
      this.showState(true);
    }
  
    @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
      evt.preventDefault();
      evt.stopPropagation();
      this.showState(null);
    }
  
    @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
      evt.preventDefault();
      evt.stopPropagation();
      this.showState(null);
    
      let files: FileHandle[] = [];
      for (let i = 0; i < evt.dataTransfer.files.length; i++) {
        const file = evt.dataTransfer.files[i];
        const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
        files.push({ file, url });
      }
      if (files.length > 0) {
        this.dropFiles.emit(files);
      }
    }
  }
  